export const breakpoints = {
	'2xs': '22.5rem', // 360 px
	xs: '35rem', // 560 px
	sm: '53.75rem', // 860 px
	md: '60rem', // 960 px
	lg: '77.5rem', // 1240 px
	xl: '90rem', // 1440 px
};
